/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    GetParcelsByClientIdParams,
    GetParcelsParams,
    PagedResponseParcelResponse,
    ParcelCreateRequest,
    ParcelResponse,
    ParcelUpdateRequest,
    ParcelWithClientResponse
} from '../models';

export type getParcelResponse200 = {
    data: ParcelWithClientResponse;
    status: 200;
};

export type getParcelResponse400 = {
    data: void;
    status: 400;
};

export type getParcelResponse500 = {
    data: void;
    status: 500;
};

export type getParcelResponseSuccess = getParcelResponse200 & {
    headers: Headers;
};

export type getParcelResponseError = (getParcelResponse400 | getParcelResponse500) & {
    headers: Headers;
};

export type getParcelResponse = getParcelResponseSuccess | getParcelResponseError;

export const getGetParcelUrl = (parcelId: string) => `/api/v1/parcels/${parcelId}`;

export const getParcel = async (
    parcelId: string,
    options?: RequestInit
): Promise<getParcelResponse> => {
    const res = await fetch(getGetParcelUrl(parcelId), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getParcelResponse['data'];

    return { data, headers: res.headers, status: res.status } as getParcelResponse;
};

export type updateParcelResponse200 = {
    data: ParcelResponse;
    status: 200;
};

export type updateParcelResponse400 = {
    data: void;
    status: 400;
};

export type updateParcelResponse500 = {
    data: void;
    status: 500;
};

export type updateParcelResponseSuccess = updateParcelResponse200 & {
    headers: Headers;
};

export type updateParcelResponseError = (updateParcelResponse400 | updateParcelResponse500) & {
    headers: Headers;
};

export type updateParcelResponse = updateParcelResponseSuccess | updateParcelResponseError;

export const getUpdateParcelUrl = (parcelId: string) => `/api/v1/parcels/${parcelId}`;

export const updateParcel = async (
    parcelId: string,
    parcelUpdateRequest: ParcelUpdateRequest,
    options?: RequestInit
): Promise<updateParcelResponse> => {
    const res = await fetch(getUpdateParcelUrl(parcelId), {
        ...options,
        body: JSON.stringify(parcelUpdateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'PUT'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as updateParcelResponse['data'];

    return { data, headers: res.headers, status: res.status } as updateParcelResponse;
};

export type archiveParcelResponse200 = {
    data: ParcelResponse;
    status: 200;
};

export type archiveParcelResponse400 = {
    data: void;
    status: 400;
};

export type archiveParcelResponse500 = {
    data: void;
    status: 500;
};

export type archiveParcelResponseSuccess = archiveParcelResponse200 & {
    headers: Headers;
};

export type archiveParcelResponseError = (archiveParcelResponse400 | archiveParcelResponse500) & {
    headers: Headers;
};

export type archiveParcelResponse = archiveParcelResponseSuccess | archiveParcelResponseError;

export const getArchiveParcelUrl = (parcelId: string) => `/api/v1/parcels/${parcelId}/archive`;

export const archiveParcel = async (
    parcelId: string,
    options?: RequestInit
): Promise<archiveParcelResponse> => {
    const res = await fetch(getArchiveParcelUrl(parcelId), {
        ...options,
        method: 'POST'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as archiveParcelResponse['data'];

    return { data, headers: res.headers, status: res.status } as archiveParcelResponse;
};

export type getParcelsByClientIdResponse200 = {
    data: PagedResponseParcelResponse;
    status: 200;
};

export type getParcelsByClientIdResponse400 = {
    data: void;
    status: 400;
};

export type getParcelsByClientIdResponse500 = {
    data: void;
    status: 500;
};

export type getParcelsByClientIdResponseSuccess = getParcelsByClientIdResponse200 & {
    headers: Headers;
};

export type getParcelsByClientIdResponseError = (
    | getParcelsByClientIdResponse400
    | getParcelsByClientIdResponse500
) & {
    headers: Headers;
};

export type getParcelsByClientIdResponse =
    | getParcelsByClientIdResponseSuccess
    | getParcelsByClientIdResponseError;

export const getGetParcelsByClientIdUrl = (
    clientId: string,
    params?: GetParcelsByClientIdParams
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/clients/${clientId}/parcels?${stringifiedParams}`
        : `/api/v1/clients/${clientId}/parcels`;
};

export const getParcelsByClientId = async (
    clientId: string,
    params?: GetParcelsByClientIdParams,
    options?: RequestInit
): Promise<getParcelsByClientIdResponse> => {
    const res = await fetch(getGetParcelsByClientIdUrl(clientId, params), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getParcelsByClientIdResponse['data'];

    return { data, headers: res.headers, status: res.status } as getParcelsByClientIdResponse;
};

export type createParcelResponse201 = {
    data: ParcelResponse;
    status: 201;
};

export type createParcelResponse400 = {
    data: void;
    status: 400;
};

export type createParcelResponse500 = {
    data: void;
    status: 500;
};

export type createParcelResponseSuccess = createParcelResponse201 & {
    headers: Headers;
};

export type createParcelResponseError = (createParcelResponse400 | createParcelResponse500) & {
    headers: Headers;
};

export type createParcelResponse = createParcelResponseSuccess | createParcelResponseError;

export const getCreateParcelUrl = (clientId: string) => `/api/v1/clients/${clientId}/parcels`;

export const createParcel = async (
    clientId: string,
    parcelCreateRequest: ParcelCreateRequest,
    options?: RequestInit
): Promise<createParcelResponse> => {
    const res = await fetch(getCreateParcelUrl(clientId), {
        ...options,
        body: JSON.stringify(parcelCreateRequest),
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        method: 'POST'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as createParcelResponse['data'];

    return { data, headers: res.headers, status: res.status } as createParcelResponse;
};

export type getParcelsResponse200 = {
    data: PagedResponseParcelResponse;
    status: 200;
};

export type getParcelsResponse400 = {
    data: void;
    status: 400;
};

export type getParcelsResponse500 = {
    data: void;
    status: 500;
};

export type getParcelsResponseSuccess = getParcelsResponse200 & {
    headers: Headers;
};

export type getParcelsResponseError = (getParcelsResponse400 | getParcelsResponse500) & {
    headers: Headers;
};

export type getParcelsResponse = getParcelsResponseSuccess | getParcelsResponseError;

export const getGetParcelsUrl = (params?: GetParcelsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/parcels?${stringifiedParams}`
        : `/api/v1/parcels`;
};

export const getParcels = async (
    params?: GetParcelsParams,
    options?: RequestInit
): Promise<getParcelsResponse> => {
    const res = await fetch(getGetParcelsUrl(params), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getParcelsResponse['data'];

    return { data, headers: res.headers, status: res.status } as getParcelsResponse;
};
